import hashify from 'object-hash';
import ContentProxy from './ContentProxy';

const Content = {
  cache: {
    getEntries: {}
  },
  setRef(clientID, client) {
    this[clientID] = client;
  },
  getEntries(query) {
    const hashified = hashify(query);

    if (!!this.cache.getEntries[hashified])
      return new Promise((resolve) =>
        resolve(this.cache.getEntries[hashified])
      );

    return ContentProxy.getEntries(query).then((val) => {
      this.cache.getEntries[hashified] = val;
      return val;
    });
  }
};

export default Content;
